import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Config, ROUTE_URL, BRAZE_ACCOUNT_MSG } from 'common/constants/SharedConstants';
import { ChannelManager } from 'common/manager';
import { login } from 'common/utilities/LoginUtils';
import ImageComponent from 'atoms/Image';
import HEADER_CONSTANT from 'organisms/HeaderComponent/AU/HeaderConstants/HeaderConstant';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ArrowIcon from 'styles/staticAssets/images/ArrowIcon.svg';
import { getAccountMsgCount } from 'common/utilities/utils';
import { UserOrderContext } from 'context/context';

export const HeaderSigninComp = props => {
  const { navRight, hamburgerComp, closeHamburger } = props;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const userParams = useSelector(data => data?.appStateReducer?.userStatus);
  const isUserNotSignedIn = !(ChannelManager.isGoogle && userParams?.loggedIn);
  const history = useHistory();
  const { LOGGEDIN_USER_SIGNIN_TEXT, GUEST_USER_SINGIN_TEXT, SIGN_IN_LINK } = HEADER_CONSTANT;
  const [messageCount, setMessageCount] = useState(0);
  const { accountCardLength = 0 } = userOrderState;

  useEffect(() => {
    window?.appboy?.openSession();
    window?.appboy?.requestContentCardsRefresh();
    const appboyMsg = getAccountMsgCount(window?.appboy?.getCachedContentCards()?.cards);
    userOrderStateDispatch({
      type: BRAZE_ACCOUNT_MSG,
      value: { accountCardLength: appboyMsg },
    });
    setMessageCount(accountCardLength);
  }, [accountCardLength, userOrderStateDispatch]);

  const signInOrAccountHandler = () => {
    if (userParams?.loggedIn) {
      closeHamburger?.();
      history.push({ pathname: ROUTE_URL.ACCOUNT });
    } else {
      login();
    }
  };

  const guestUserText = item => {
    return hamburgerComp ? translateWithI18Next(GUEST_USER_SINGIN_TEXT) : item?.name;
  };

  return (
    <div
      className='sign-in-container'
      data-testid={props['data-testid']}
      data-id={isUserNotSignedIn ? Config.HEADER_SIGN_IN_ATTR_DATA_ID : ''}
    >
      {navRight
        ?.filter(item => item?.title?.toUpperCase() === SIGN_IN_LINK)
        ?.map(item => (
          <div
            className='account-container'
            key={item?.title}
            data-testid='account-container'
            onClick={signInOrAccountHandler}
          >
            <ImageComponent srcFile={item?.url || item?.imageUrl} className='account-icon' />
            {!!messageCount && userParams?.loggedIn && <span className='msg-badge'>{messageCount}</span>}

            <span className='sign-in-text'>
              {userParams?.loggedIn ? translateWithI18Next(LOGGEDIN_USER_SIGNIN_TEXT) : guestUserText(item)}
            </span>
            {hamburgerComp ? <ImageComponent srcFile={ArrowIcon} className='arrow' /> : null}
          </div>
        ))}
    </div>
  );
};
